import React from 'react';
const MALE = [{
  category: '- 33 Kg / 73 lbs',
  size: '#0',
  level: '17'
}, {
  category: '- 37 Kg / 82 lbs',
  size: '#0',
  level: '18'
}, {
  category: '- 41 Kg / 90 lbs',
  size: '#1',
  level: '19'
}, {
  category: '- 45 Kg / 99 lbs',
  size: '#1',
  level: '21'
}, {
  category: '- 49 Kg / 108 lbs',
  size: '#2',
  level: '22'
}, {
  category: '- 53 Kg / 117 lbs',
  size: '#2',
  level: '24'
}, {
  category: '- 57 Kg / 126 lbs',
  size: '#2',
  level: '25'
}, {
  category: '- 61 Kg / 134 lbs',
  size: '#3',
  level: '27'
}, {
  category: '- 65 Kg / 143 lbs',
  size: '#3',
  level: '28'
}, {
  category: '+ 65 Kg / 143 lbs',
  size: '#3',
  level: '30'
}];
const FEMALE = [{
  category: '- 29 Kg / 64 lbs',
  size: '#0',
  level: '16'
}, {
  category: '- 33 Kg / 73 lbs',
  size: '#0',
  level: '17'
}, {
  category: '- 37 Kg / 82 lbs',
  size: '#0',
  level: '18'
}, {
  category: '- 41 Kg / 90 lbs',
  size: '#1',
  level: '19'
}, {
  category: '- 44 Kg / 97 lbs',
  size: '#1',
  level: '20'
}, {
  category: '- 47 Kg / 104 lbs',
  size: '#2',
  level: '21'
}, {
  category: '- 51 Kg / 112 lbs',
  size: '#2',
  level: '22'
}, {
  category: '- 55 Kg / 121 lbs',
  size: '#2',
  level: '23'
}, {
  category: '- 59 Kg / 130 lbs',
  size: '#3',
  level: '24'
}, {
  category: '+ 59 Kg / 130 lbs',
  size: '#3',
  level: '25'
}];
type Row = {
  category: string;
  size: string;
  level: string;
};
/**
 * Cadet Level tables (male + female). Owns its own data and table markup.
 */
export function CadetLevel() {
  return <div className="space-y-12" data-id="element-822">
      <Table title="Cadet MALE" headerBg="bg-blue-600" rows={MALE} data-id="element-823" />
      <Table title="Cadet FEMALE" headerBg="bg-pink-600" rows={FEMALE} data-id="element-824" />
    </div>;
}
function Table({
  title,
  headerBg,
  rows
}: {
  title: string;
  headerBg: string;
  rows: Row[];
}) {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-825">
      <div className={`${headerBg} px-6 py-4`} data-id="element-826">
        <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-827">
          {title}
        </h2>
      </div>
      <div data-id="element-828">
        <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-829">
          <tbody data-id="element-830">
            <tr className="border-b border-gray-200 bg-gray-50" data-id="element-831">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-832">
                Category
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 text-gray-600 font-medium" data-id="element-833">
                  {item.category}
                </td>)}
            </tr>
            <tr className="border-b border-gray-200" data-id="element-834">
              <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-835">
                Size
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-836">
                  {item.size}
                </td>)}
            </tr>
            <tr className="bg-gray-50" data-id="element-837">
              <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-838">
                LEVEL
              </td>
              {rows.map((item, i) => <td key={i} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-839">
                  {item.level}
                </td>)}
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}